<template>
  <div class="dlrQuotationLoad">
    <div class="dlrQuotationLoad-bg">
      <div
        v-marquee="{ duration: 8000 }"
        class="dlrQuotationLoad-left dlrQuotationLoad-left--marquee"
      >
        <p>
          <em>{{ seriesName }}</em
          ><span>预计全款落地价</span><ins>{{ fullLandingPrice }}万元</ins>
        </p>
        <p>
          <em>{{ seriesName }}</em
          ><span>预计贷款落地价</span><ins>{{ loanLandingPrice }}万元</ins>
        </p>
      </div>
      <div class="dlrQuotationLoad-right">
        <a class="disabled" href="javascript:void(0);">
          <span>接通后看明细</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, defineComponent } from 'vue-demi';
import store from '../../store/index';
import utils from '../../utils/util';
export default defineComponent({
  name: 'DlrQuotationLoad',
  setup(props) {
    const priceListResult = computed(
      () => store.state.priceList.priceListResult,
      );
    const dealerSeriesList = computed(() => store.getters['dealer/seriesList']);
    const loanLandingPrice = computed(() => {
      const price = utils.wanFilterWithUnit(
        priceListResult.value?.loan?.loanLandingPrice,
      );
      return utils.formatMoney(price.value);
    });
    const fullLandingPrice = computed(() => {
      const price = utils.wanFilterWithUnit(
        priceListResult.value.fullLandingPrice / 10000,
      );
      return utils.formatMoney(price.value);
    });
    const salesSeriesId = computed(() => store.state.dealer.salesSeriesId);
    const seriesName = computed(() => {
      let seriesInfo = dealerSeriesList.value.find(
        (o) => o.SeriesId === salesSeriesId.value,
      );
      if (seriesInfo) {
        return seriesInfo.SeriesName;
      }
      return '';
    });
    return {
      seriesName,
      loanLandingPrice,
      fullLandingPrice,
    };
  },
});
</script>
<style lang="scss">
@import '@/assets/scss/modules/VR/dlrQuotationLoad.scss';
</style>
